module.exports = __webpack_public_path__ + "static/media/client-7.83639554.jpg";